// CSS
import '_Asset/css/User/Page/addition.css';

// Component
import dompurify from 'dompurify';


const PvPolicy = () => {

  const sanitizer = dompurify.sanitize;

  return (
    <>
      {/* Visual */}
      <div className="visual addition center">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">개인정보 처리방침</h2>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="additionArea areaBox">
            <pre dangerouslySetInnerHTML={{ __html: sanitizer(`
'(주)페이게이트'(이하 '회사')가 제공하는 모든 금융 상품 및 서비스(‘전자금융업무’라 함)를 통해 취급하는 모든 개인정보는 관련 법령에 근거하여 수집·보유 및 처리되고 있으며 회사는 이용자의 개인정보를 중요시하며, ‘정보통신망 이용촉진 및 정보보호에 관한 법률’ 및 ‘개인정보보호법’ 그리고 ‘신용정보의 이용 및 보호에 관한 법률’에 따라 이용자의 개인정보 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같이 처리방침을 수립하여 준수하고 있습니다. 

회사는 개인정보처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 

회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.

<h2>1. 개인정보의 처리 및 이용목적</h2>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.

① 서비스 제공 계약의 성립, 유지, 종료를 위한 본인 식별 및 실명확인, 각종 회원관리, 계약서 발송 등
② 서비스 제공 과정 중 본인 식별, 인증, 실명 확인 및 각종 안내/고지
③ 부정 이용방지 및 비인가 사용 방지
④ 서비스 제공 및 관련 업무 처리에 필요한 동의 또는 철회 등 의사확인
⑤ 이용 빈도 파악 및 인구통계학적 특성에 따른 서비스 제공 및 CRM
⑥ 서비스 제공을 위한 각 결제 수단 별 상점 사업자 정보 등록
⑦ 휴대폰 본인확인서비스 제공
⑧ 서비스 제공 (거래 승인 등) 및 관련 업무처리(민원, 개인정보 관리상태 점검 등)를 위해 이용자와 해당 결제수단에 관한 계약을 체결한 이용자의 해당 결제수단 발행자 (ex) 신용카드의 경우 해당 신용카드사)에게 이용자의 결제정보, 개인정보 보관내역 등 전송 (결제수단 발행자에 대한 상세 내용 아래 참조)

※ 결제수단별 발행자

가. 신용카드 : 국민, 비씨, 롯데, 삼성, NH농협, 현대, 신한, 하나 등 신용카드사
나. 계좌이체 : 
은행 (IBK, KB국민, 우리, KEB하나, SC제일,신한, 산업, 한국씨티, 수협중앙회, 농협중앙회, 단위농협, 대구,   부산, 광주, 제주, 전북, 경남, 새마을금고, 신협중앙회, 우체국, 산림조합)
증권 (유안타, 현대, 미래에셋, 한국투자, NH투자, 하이투자, HMC투자, SK, 대신, 하나금융투자, 신한금융투자, 동부, 유진투자, 메리츠종금, 신영, 삼성, 한화투자, 미래에셋대우), 
다. 휴대폰, 전화결제 : 통신사(SKT, KT, LGU+), 다날
라. ARS신용카드 : 신용카드사
마. 본인확인 : 통신사(SKT, KT, LGU+), NICE신용정보
바. 포인트 :

<h2>2. 수집하는 개인정보 항목 [개인정보 파일 현황]</h2>회사는 전자지급결제대행서비스 및 결제대금예치서비스, 결제중계서비스, KYC인증 그리고 휴대폰 본인확인서비스(이하 ‘서비스’라 함)신청, 상담, 문의사항 등, 전자금융업자로서 전자금융업무 서비스의 제공을 위하여 아래와 같은 개인정보를 수집하고 있습니다.
1) 필수항목
① 개인정보 항목 
로그인ID, 비밀번호, 비밀번호 질문과 답, 이메일, 성명, 주민등록번호, 생년월일, 성별, 휴대전화번호, 자택주소, 자택전화번호, 회사전화번호, 회사명, 은행계좌정보, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 법정대리인 이름, 법정대리인 자택 전화번호, 법정대리인 자택 주소, 법정대리인 휴대전화번호
② 기업정보 항목
회사명, 사업자등록번호(개인사업자등록번호/법인사업자등록번호), 법인등록번호, 회사전화번호, 회사주소, 법인은행계좌정보
③ 상기 명시된 개인(기업)정보 항목 이외의 ‘서비스’ 이용과정이나 ‘서비스’ 처리 과정에서 다음과 같은 추가 정보들이 자동 혹은 수동으로 생성되어 수집될 수 있습니다. 

   - 접속 IP/MAC Address
   - 쿠키(Cookie)
   - 이메일(e-mail)
   - 서비스 접속 일시
   - 서비스 이용기록
   - 불량 혹은 비정상 이용기록
   - 결제기록
④ 기타
회사는 서비스 이용과 관련한 대금결제, 환불 등에 필요한 카드사명, 카드번호(일부), 은행명, 계좌번호, 통신사명등 결제수단의 정보를 추가로 수집할 수 있습니다.
회사는 휴대폰 본인확인서비스를 위하여 성명, 생년월일, 휴대폰번호, 성별, 내/외국인구분, 통신사 등을 수집할 수 있습니다.
2). 선택항목

① 필수항목 이외에 계약서류에 기재된 정보 또는 고객이 제공한 정보
② 실제 거주 주소, 팩스번호 등

2) 수집방법

홈페이지(서비스 신청 게시판, 서비스 상담 게시판, 문의사항 게시판), 서면양식, 팩스, 이메일, 업무제휴 계약을 체결한 제휴사로부터 고객이 제시하는 개인정보 수집 및 생성정보 수집 툴을 통한 수집

<h2>3. 개인정보의 보유 및 이용기간</h2>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기 합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
1) 회사 내부 방침에 의한 정보보유
- 부정이용방지와 비인가사용방지를 위한 결제 이용에 관한 기록
- 보존기간 : 5년
- 휴대폰 본인확인서비스 이용에 관한 기록
- 보존기간 : 1년 / 보존근거 : 내부방침

2) 관련법령에 의한 정보보유
상법, 전자상거래 등에서의 소비자보호에 관한 법률, 전자금융거래법 등 관련법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관련법령에서 정한 일정한 기간 동안 정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
- 신용정보의 수집/처리 및 이용 등에 관한 기록
보존기간 : 3년 / 보존근거 : 신용정보의 이용 및 보호에 관한 법률
- 소비자의 불만 또는 분쟁처리에 관한 기록
보존기간 : 3년 / 보존근거 : 전자상거래 등에서의 소비자보호에 관한 법률
- 대금결제 및 재화 등의 공급에 관한 기록
보존기간 : 5년 / 보존근거 : 전자상거래 등에서의 소비자보호에 관한 법률
(단, 건당 거래 금액이 1만원 이하의 경우에는 1년간 보존합니다.)
- 계약 또는 청약철회 등에 관한 기록
보존기간 : 5년 / 보존근거: 전자상거래 등에서의 소비자보호에 관한 법률
- 방문에 관한 기록
보존기간 : 3개월 / 보존근거 : 통신비밀보호법

<h2>4. 개인정보의 제3자 제공에 관한 사항</h2>회사는 이용자의 개인정보를 [2. 수집하는 개인정보의 이용목적]에서 고지한 범위 내에서 개인정보 제공자에게 사전 통지 후 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나, 개인정보보호법 제18조에 따라 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
- 개인정보호법 제15조 제1항에 따라, 이용자들이 사전에 동의한 경우(이용자가 사전에 동의한 경우 란, 서비스 이용 등을 위하여 이용자가 자발적으로 자신의 개인정보를 제3자에게 제공하는 것에 동의하는 것을 의미합니다)
- 개인정보호법 제15조 제1항 제2호 제3호 제5호에 따라 개인정보를 수집한 목적 범위에서 개인정보를 제공하는 경우
이러한 경우에도, 회사는 이용자에게 (1) 개인정보를 제공받는 자, (2) 그의 이용목적, (3) 제공되는 개인정보의 항목, (4) 개인정보의 보유 및 이용기간을 사전에 고지하고 이에 대해 명시적/개별적으로 동의를 얻습니다. 이와 같은 모든 과정에 있어서 회사는 이용자의 의사에 반하여 추가적인 정보를 수집하거나, 동의의 범위를 벗어난 정보를 제3자와 공유하지 않습니다.
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

<h2>5. 개인정보처리의 위탁에 관한 사항</h2>회사는 서비스 이행을 위하여 이용자들의 개인정보를 외부전문업체에 위탁하여 운영하거나 위탁업무의 내용이나 수탁자가 변경될 경우에는 미리 그 사실을 이용자들에게 공지할 것입니다. 
또한, 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행 목적 외 개인정보보호 관련 지시 엄수, 개인정보에 관한 비밀유지, 개인정보 처리금지, 기술·관리적 보호조치, 재 위탁 제한(제3자 제공의 금지), 수탁자에 대한 관리․감독, 사고시의 책임부담, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있으며, 위탁기간 종료 즉시 개인정보의 반납/파기 의무 등을 명확히 규정하고 당해 계약 내용을 서면 또는 전자적으로 보관하여 이용자의 권익을 보호할 것입니다.

<h2>6. 이용자 및 법정대리인의 권리·의무 및 그 행사방법</h2>1) 이용자는 개인정보주체로서 언제나 다음과 같은 권리를 행사할 수 있으며, 이에 대해 당사는 지체 없이 필요한 조치를 취합니다. 또한 회사는 오류정정 요구가 있을 시 그 정정 때까지 당해 해당정보를 이용하지 않습니다.

① 이용자는 회사에 대해 언제든지 개인정보 열람,정정,삭제,처리정지 요구 등의 권리를 행사할 수 있습니다.
② 제1항에 따른 권리 행사는 회사에 대해 개인정보 보호법 시행령 제41조제1항에 따라, 회사 고객센터 (02.2140.2700) 전화로 연락하거나 방문, 서면, E-mail을 통하여 이용자 본인임을 확인한 후 정보 열람/정정/삭제 신청을 하실 수 있습니다.(이용자가 회사의 개인정보 이용에 대한 동의를 철회하고자 하는 경우에도 이와 같습니다). 
③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.
④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
⑦ 만 14세 미만 아동(이하 ‘아동’)이 당사의 서비스를 이용하고자 하는 경우에는 법정대리인의 동의를 득해야 합니다. 회사는 법정대리인의 동의를 받기 위하여 아동으로부터 법정대리인의 성명과 연락처 등 최소한의 정보를 요구할 수 있습니다. 아동의 법정대리인은 서면, 전화, E-mail, FAX 등을 통하여 아동의 개인정보에 대한 열람, 정정 및 삭제를 요청할 수 있으며, 이러한 요청이 있는 경우 회사는 지체 없이 필요한 조치를 취합니다.

<h2>7. 개인정보의 파기절차 및 방법</h2>1) 파기절차
이용자가 서비스 신청, 서비스 상담, 문의사항 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유목적 이외의 다른 목적으로 이용되지 않습니다.

2) 파기기한
이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정
보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보
의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.



3) 파기방법
- 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

<h2>8. 개인정보의 안정성 확보조치</h2>회사는 개인정보의 안정성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

1) 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등
2) 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
3) 물리적 조치 : 전산실, 자료보관실 등의 접근통제

<h2>9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h2>회사는 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'을 설치 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키 등을 사용합니다.

1) 쿠키 등 사용 목적
- 홈페이지 이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
- 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.

2) 쿠키 설정 거부 방법
- 쿠키 설정을 거부하는 방법으로는 이용자가 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
- 설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보

3) 단, 이용자께서 쿠키 설치를 거부하였을 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.

<h2>10. 개인정보 처리방침 변경</h2>1) 특히 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

<h2>11. 개인정보의 안전성 확보 조치</h2>회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
1) 정기적인 자체 감사 실시
개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.
2) 개인정보 취급 직원의 최소화 및 교육
개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.
3) 내부관리계획의 수립 및 시행
개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
4) 해킹 등에 대비한 기술적 대책
회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
5) 개인정보의 암호화
이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
6) 접속기록의 보관 및 위·변조 방지
개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위·변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.
7) 개인정보에 대한 접근 제한
개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
8) 문서보안을 위한 잠금장치 사용
개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
(비인가자에 대한 출입 통제
개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.

<h2>12. 개인정보 열람청구</h2>1) 정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
▶  개인정보 열람청구 접수·처리 부서
부서명 : CS TEAM
담당자 : 이대규
연락처 : 02.2140.2700
이메일 : cs@paygate.net
2) 정보주체는 제1항의 열람청구 접수·처리부서 이외에, 행정안전부의 “개인정보보호 종합지원 포털” 웹사이트(www.privacy.go.kr)를 통하여서도 개인정보 열람청구를 하실 수 있습니다.
▶ 행정안전부 개인정보보호 종합지원 포털 → 개인정보 민원 → 개인정보 열람등 요구 (본인확인을 위하여 아이핀(I-PIN)이 있어야 함)

<h2>13. 정보주체의 권익침해에 대한 구제방법</h2>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.
▶  개인정보 침해신고센터 (한국인터넷진흥원 운영)
- 소관업무 : 개인정보 침해사실 신고, 상담 신청
- 홈페이지 : privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
▶  개인정보 분쟁조정위원회
- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
- 홈페이지 : www.kopico.go.kr
- 전화 : (국번없이) 1833-6972
- 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층
▶ 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)
▶ 경찰청 사이버안전국 : 182 (http://cyberbureau.police.go.kr)
            `)}}>
            </pre>
          </div>
        </div>
      </div>
    </>
  )
}

export default PvPolicy
